import React from 'react'
import * as Functions from '../../functions'

export default function Container({ children, className, style }) {
    return <div className={Functions.classNames('layouts-container', className)} style={style}>
        {children}
    </div>
}